import { render, staticRenderFns } from "./Assembly.vue?vue&type=template&id=ad4b3cfe&scoped=true"
import script from "./Assembly.vue?vue&type=script&lang=ts"
export * from "./Assembly.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad4b3cfe",
  null
  
)

export default component.exports